import React from 'react';
import { Icon, IconsEnum } from 'components/Icons';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';
import { setIsInfoOpen } from 'features/sport/sportSlice';

import styles from './SportResultsAndInfoToggler.module.scss';
import { selectIsInfoOpen } from 'features/sport/selectors';
import classNames from 'classnames';
import { SportResultsAndInfoTogglerProps } from 'features/sport/components/sportResultsAndInfoToggler';

export const SportResultsAndInfoToggler = ({ providerID }: SportResultsAndInfoTogglerProps) => {
  const dispatch = useAppDispatch();
  const isInfoOpen = useTypedSelector(selectIsInfoOpen);

  if (!!providerID && providerID !== '0') {
    return (
      <button type="button" className={classNames(styles.statBtn)} onClick={() => dispatch(setIsInfoOpen(!isInfoOpen))}>
        <Icon
          key={`toggler-${isInfoOpen}`}
          color={`var(${isInfoOpen ? '--color-primary' : '--color-on-bg-primary'})`}
          iconId={isInfoOpen ? IconsEnum.CLOSE : IconsEnum.STATS}
          className={classNames(styles.iconStats, { [styles.smaller]: isInfoOpen })}
        />
      </button>
    );
  }

  return null;
};